// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"5a657e2b","96":"1499838a","869":"5abe5a78"}[chunkId] + ".chunk.css";
};